<div class="main-slider">
  <swiper-container class="swiper-container h-100" [appSwiper]="config" init="false">
    @for (slide of slides; track slide) {
      <swiper-slide class="swiper-slide">
        <div [style.background-image]="'url(' + slide.image + ')'" class="slide-item">
          <div class="container1 sl-wrap">
            <div class="content fx-col fx-main-center fx-cross-center" >
              <div class="w-100">
                <h1 class="swiper_h1">{{slide.title}}</h1>
                <h3 class="swiper_h3">{{slide.subtitle}}</h3>
              </div>
              <button mat-raised-button color="primary">Shop now</button>
            </div>
          </div>
        </div>
      </swiper-slide>
    }
    <div slot="container-end" class="swiper-pagination white"></div>
    <button slot="container-end" mat-mini-fab color="primary" class="swiper-button-prev swipe-arrow">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button slot="container-end" mat-mini-fab color="primary" class="swiper-button-next swipe-arrow">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </swiper-container>
</div>